// 1977 Topps Series 4 — GENERATED by pipeline-publish (2026-05-30)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/1977-series-4.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "1977-series-4",
//     name: "1977 Topps Series 4",
//     shortName: "Series 4 1977",
//     year: 1977,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "1977",
//     totalCards: 78,
//     description: "Topps 1977 Topps Series 4 trading card set.",
//     color: "#888aa0",
//     accentColor: "#f0c040",
//     dataFile: "1977-series-4",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [],
    cards: [
        { n: "199", name: "The Star Warriors Aim for Action!" },
        { n: "200", name: "C-3P0 Searches for his Counterpart" },
        { n: "201", name: "Raid at Mos Eisley!" },
        { n: "202", name: "Inquiring About Obi-Wan Kenobi" },
        { n: "203", name: "A Band of Jawas" },
        { n: "204", name: "Stalking the Corridors of the Death Star" },
        { n: "205", name: "Desperate Moments for Our Heroes!" },
        { n: "206", name: "Searching for the Missing Droid" },
        { n: "207", name: "C-3P0 (Anthony Daniels)" },
        { n: "207 X", name: "C-3P0 (Anthony Daniels) Xrated" },
        { n: "208", name: "Luke Skywalker on the Desert Planet" },
        { n: "209", name: "The Rebel Troops" },
        { n: "210", name: "Princess Leia Blasts the Enemy" },
        { n: "211", name: "A Proud Moment for Han and Luke" },
        { n: "212", name: "A Stormtrooper is Blasted!" },
        { n: "213", name: "Monitoring the Battle" },
        { n: "214", name: "Luke and Leia Shortly Before the Raid" },
        { n: "215", name: "Han Bows Out of Battle" },
        { n: "216", name: "Han and Leia Quarrel About the Escape Plan" },
        { n: "217", name: "The Dark Lord of the Sith" },
        { n: "218", name: "Luke Skywalker's Home . . . Destroyed!" },
        { n: "219", name: "The Swing to Freedom!" },
        { n: "220", name: "\"I'm Going to Regret This!\"" },
        { n: "221", name: "Princess Leia (Carrie Fisher)" },
        { n: "222", name: "\"Evacuate? In our moment of triumph?\"" },
        { n: "223", name: "Han Solo covers his friends" },
        { n: "224", name: "Luke's secret yen for action!" },
        { n: "225", name: "Aunt Beru Lars (Shelagh Fraser)" },
        { n: "226", name: "Portrait of a princess" },
        { n: "227", name: "Instructing the Rebel pilots" },
        { n: "228", name: "R2-D2 is inspected by the Jawas" },
        { n: "229", name: "Grand Moff Tarkin (Peter Cushing)" },
        { n: "230", name: "Guarding the Millennium Falcon" },
        { n: "231", name: "Discussing the Death Star's future" },
        { n: "232", name: "The Empire strikes back!" },
        { n: "233", name: "Raiding the Rebel starship" },
        { n: "234", name: "Envisioning the Rebel's destruction" },
        { n: "235", name: "Luke Skywalker (Mark Hamill)" },
        { n: "236", name: "Readying the Rebel fleet" },
        { n: "237", name: "The deadly grip of Darth Vader" },
        { n: "238", name: "Uncle Owen Lars (Phil Brown)" },
        { n: "239", name: "The young star warrior" },
        { n: "240", name: "Artoo's desperate mission!" },
        { n: "241", name: "The Rebel fighter ships" },
        { n: "242", name: "Death Star shootout!" },
        { n: "243", name: "Rebels in the trench!" },
        { n: "244", name: "Waiting at Mos Eisley" },
        { n: "245", name: "Member of the evil Empire" },
        { n: "246", name: "Stormtrooper - tool of the Empire" },
        { n: "247", name: "Soldier of evil!" },
        { n: "248", name: "Luke suspects the worst about his family" },
        { n: "249", name: "Ben Kenobi (Alec Guinness)" },
        { n: "250", name: "Luke and Ben on Tatooine" },
        { n: "251", name: "An overjoyed Han Solo!" },
        { n: "252", name: "The honored heroes!" },
        { n: "253", name: "R2-D2 (Kenny Baker)" },
        { n: "254", name: "Darth Vader (David Prowse)" },
        { n: "255", name: "Luke poses with his weapon" },
        { n: "256", name: "The marvelous droid See-Threepio!" },
        { n: "257", name: "A pair of Jawas" },
        { n: "258", name: "Fighting impossible odds!" },
        { n: "259", name: "Challenging the evil Empire!" },
        { n: "260", name: "Han Solo (Harrison Ford)" },
        { n: "261", name: "Fury of the Tusken Raider" },
        { n: "262", name: "Creature of Tatooine" },
        { n: "263", name: "The courage of Luke Skywalker" },
        { n: "264", name: "Star pilot Luke Skywalker" },
    ],
  },
  {
    id: "sticker",
    type: "insert",
    title: "STICKER",
    parallels: [],
    cards: [
        { n: "34", name: "The Star Warriors Aim for Action!" },
        { n: "35", name: "Han Solo (Harrison Ford)" },
        { n: "36", name: "Star Pilot (Luke Skywalker" },
        { n: "37", name: "The Marvelous Droid See-Threepio" },
        { n: "38", name: "R2-D2 (Kenny Baker)" },
        { n: "39", name: "Creature of Tatooine" },
        { n: "40", name: "Darth Vader (David Prowse)" },
        { n: "41", name: "A Pair of Jawas" },
        { n: "42", name: "Luke Poses with his Weapon" },
        { n: "43", name: "Stormtrooper - tool of the Empire" },
        { n: "44", name: "Monitoring the Battle" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
